"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Link___StyledSvg",
  componentId: "sc-1ezye4v-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Link(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M157.542 370.827l74.255-74.256 45.79 45.79-97.15 97.15c-6.315 6.348-14.605 9.489-22.895 9.489s-16.58-3.174-22.895-9.488l-97.15-97.15c-12.662-12.662-12.662-33.129 0-45.79l97.15-97.15 45.79 45.79-74.255 74.255 51.36 51.36zm281.962-236.205c12.661 12.662 12.661 33.16 0 45.823l-97.15 97.15-45.79-45.79 74.254-74.255-51.36-51.36-74.255 74.222-45.79-45.79 97.15-97.15c12.662-12.63 33.129-12.63 45.79 0l97.15 97.15zm-175.322 32.385l45.797 45.796-97.158 97.158-45.796-45.797 97.157-97.157z"
  }));
}

var _default = Link;
exports["default"] = _default;